import "intersection-observer";
// XboxLive.Social needs the reflect-metadata polyfill, it's an unfortunate dependency bleed at the moment
import "reflect-metadata";

// @azure/msal-browser uses window.crypto.randomUUID() but it is not supported in Chrome M85 (TV) so
// we need to polyfill. Also, this polyfill does not support import so you must use require
// https://github.com/uuidjs/randomUUID
require("randomuuid");
